var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('span',[_vm._v("在线咨询")]),_c('span',[_c('img',{attrs:{"src":require("../../public/images/1-2.png")}})]),_c('span',[_c('div',[_c('span'),_vm._v(" QQ交谈 ")])])])
}]

export { render, staticRenderFns }